export const SERVICE_WORKER_UPDATE_INTERVAL_MS = 600_000;

export function isBrowserOnline(): boolean {
  return typeof navigator !== 'undefined' && navigator.onLine;
}

export function checkForServiceWorkerUpdate(registration: ServiceWorkerRegistration): void {
  if (!isBrowserOnline()) {
    return;
  }

  registration.update().catch((error: unknown) => {
    console.warn('Service worker update check failed (non-fatal):', error);
  });
}

export function setupServiceWorkerUpdateChecks(registration: ServiceWorkerRegistration): void {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkForServiceWorkerUpdate(registration);
    }
  });

  globalThis.addEventListener('pageshow', (event: PageTransitionEvent) => {
    if (event.persisted) {
      checkForServiceWorkerUpdate(registration);
    }
  });

  globalThis.addEventListener('online', () => {
    checkForServiceWorkerUpdate(registration);
  });

  setInterval(() => {
    checkForServiceWorkerUpdate(registration);
  }, SERVICE_WORKER_UPDATE_INTERVAL_MS);
}

export function registerProductionServiceWorker(): void {
  navigator.serviceWorker.register('/ngsw-worker.js')
    .then((registration) => {
      console.log('Angular Service Worker registered successfully:', registration);
      setupServiceWorkerUpdateChecks(registration);
    })
    .catch((error: unknown) => {
      console.warn('Angular Service Worker registration failed:', error);
    });
}

export function registerDevelopmentServiceWorker(): void {
  navigator.serviceWorker.register('/custom-sw.js')
    .then((registration) => {
      console.log('Custom Service Worker registered (dev mode):', registration);
    })
    .catch((error: unknown) => {
      console.warn('Custom Service Worker registration failed (dev mode):', error);
    });
}
